import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-job-portal',
  templateUrl: './job-portal.component.html',
  styleUrls: ['./job-portal.component.scss']
})
export class JobPortalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
